export default __webpack_public_path__ + "static/netent-play-n-go-pragmatic-play-b264d253397678266e1627f81b3e75d2.jpg";